// extracted by mini-css-extract-plugin
export default {"searchInput":"CategoriesModal_searchInput__8XU5j","searchButton":"CategoriesModal_searchButton__EZqdJ","search":"CategoriesModal_search__aebI4"};